import React, { createContext, useState, useEffect } from "react";

// Create the RoleContext
export const RoleContext = createContext();

// Create a provider component
export const RoleProvider = ({ children }) => {
    // Get the role from localStorage if available
    const storedRole = localStorage.getItem("role") || "";

    const [role, setRole] = useState(storedRole);

    // Update localStorage whenever the role changes
    useEffect(() => {
        if (role) {
            localStorage.setItem("role", role);
        }
    }, [role]);

    return (
        <RoleContext.Provider value={{ role, setRole }}>
            {children}
        </RoleContext.Provider>
    );
};
